import tippy from 'tippy.js';

let tooltipsObserver;

function initializeTooltipsInRoot(root) {
	const container = root && root.querySelectorAll ? root : document;
	const elements = container.querySelectorAll('[data-tippy-content]');
	if (!elements.length) {
		return;
	}

	elements.forEach((el) => {
		if (el._tippy) {
			return;
		}
		tippy(el, {
			allowHTML: false,
			placement: 'top',
			trigger: 'mouseenter focus',
			interactive: false,
			maxWidth: 280,
		});
	});
}

export default function initTooltips() {
	initializeTooltipsInRoot(document);

	if (tooltipsObserver) {
		return;
	}

	tooltipsObserver = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			mutation.addedNodes.forEach((node) => {
				if (!node || node.nodeType !== 1) {
					return;
				}
				initializeTooltipsInRoot(node);
			});
		});
	});

	if (document.body) {
		tooltipsObserver.observe(document.body, { childList: true, subtree: true });
	}
}
